/**
 * Belize dollar.
 */
export var BZD = {
  code: 'BZD',
  base: 10,
  exponent: 2
};